var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/foxySelected.4f997bfa.png","uri@3x": __webpack_public_path__ + "static/media/foxySelected.69f95df9.png","uri@2x": __webpack_public_path__ + "static/media/foxySelected.f121ff58.png",
    width: 21,
    height: 21
});